import React from 'react';

interface IHeaderProps {
    stage: number;
}

export default function HeaderProcess(props: IHeaderProps) {
  const { stage } = props;

  return (
    <section className="container-fluid custom-progress-bar">
      <div className="container">
        <div className="row justify-content-center">
            <div className="col-12 col-sm-12 col-md-9 col-lg-7">
                <div className="d-flex w-100 justify-content-between">
                    <div className="header-title d-flex align-items-center align-content-center text-left">
                        <img
                            src="https://sfestaticos.blob.core.windows.net/pmc/salud/assets/svg/salud-complementario/Icon_salud-filled.svg"
                            alt=""
                            height="24"
                            width="24"
                        /> <p className="m-0">Seguro de <b> Salud complementario</b></p>
                    </div>
                    <div className="stage-info d-flex justify-content-end align-items-end align-content-end text-right">
                        <p className="p-0 m-0 px-12">Paso {stage} de 5</p>
                    </div>
                </div>
                <div className="d-flex w-100 relative mt-8 progress-bar" stage-value={stage * 20}></div>
            </div>
        </div>
      </div>
    </section>
  );
}
